import axiosInstance from './api/axiosInstance';
import { REDIRECT_URL } from './settings';

export const get_tokens =(code) =>
    axiosInstance
        .post("space/authenticate-calendar/google/tokens",{
            code,
            redirectUri:REDIRECT_URL
        })
        .then(res => {
            return res;
        })
        .catch(error => {
            throw error;
});

export const getAuthorizedEmail=async (accessToken)=>{
   try {
        const res = await axiosInstance
            .get(`https://www.googleapis.com/oauth2/v3/userinfo?access_token=${accessToken}`);
        return res;
    } catch (e) {
        throw e;
    }
        
}


